function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2595.476,1566.8h6.409v2h-6.93a8.063,8.063,0,0,0,0,2h6.93v2h-6.409c1.142,2.783,3.943,5,8.409,5h6v2h-6c-5.845,0-9.353-3.179-10.539-7h-3.461v-2h3.051a10.29,10.29,0,0,1,0-2h-3.051v-2h3.461c1.186-3.821,4.694-7,10.539-7h6v2h-6C2599.419,1561.8,2596.618,1564.014,2595.476,1566.8Z",
  transform: "translate(-2589.885 -1559.797)",
  fill: "gray"
});

var SvgEuro = function SvgEuro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEuro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/euro.9943107f.svg";
export { ForwardRef as ReactComponent };